// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2mrcQ","info":"UpdateTermsInfo_info__6ta7r"};